import { library } from '@fortawesome/fontawesome-svg-core';
import {
	faFacebook,
	faFacebookF,
	faFacebookSquare,
	faGolang,
	faGooglePlusG,
	faGulp,
	faHotjar,
	faHtml5,
	faInstagram,
	faJs,
	faLinkedin,
	faLinkedinIn,
	faMediumM,
	faNodeJs,
	faPinterest,
	faSass,
	faTrello,
	faTwitter,
	faWatchmanMonitoring,
	faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import {
	faCalendarDays,
	faCommentDots,
	faCircle as farCircle,
	faClock as farClock,
	faComment as farComment,
	faCopy as farCopy,
	faDizzy as farDizzy,
	faEdit as farEdit,
	faFile as farFile,
	faFileArchive as farFileArchive,
	faFileAudio as farFileAudio,
	faFileCode as farFileCode,
	faFileExcel as farFileExcel,
	faFileImage as farFileImage,
	faFilePdf as farFilePdf,
	faFileVideo as farFileVideo,
	faFileWord as farFileWord,
	faHeart as farHeart,
	faImage as farImage,
	faLaughBeam as farLaughBeam,
	faLightbulb as farLightbulb,
	faObjectUngroup as farObjectUngroup,
	faPaperPlane as farPaperPlane,
	faQuestionCircle as farQuestionCircle,
	faSmileBeam as farSmileBeam,
	faSquareCheck as farSquareCheck,
	faStar as farStar,
	faWindowRestore,
} from '@fortawesome/free-regular-svg-icons';
import {
	faAdjust,
	faAlignLeft,
	faAlignRight,
	faAngleDown,
	faAngleLeft,
	faAngleRight,
	faAngleUp,
	faArchive,
	faArrowDown,
	faArrowLeft,
	faArrowRight,
	faArrowTrendDown,
	faArrowsAltV,
	faArrowsRotate,
	faArrowUp,
	faAt,
	faAward,
	faBalanceScaleLeft,
	faBan,
	faBars,
	faBarsStaggered,
	faBell,
	faBolt,
	faBook,
	faBookOpen,
	faBox,
	faBoxOpen,
	faBoxes,
	faBuilding,
	faBrush,
	faBug,
	faCalendarAlt,
	faCalendarCheck,
	faCalendarDay,
	faCamera,
	faCameraRetro,
	faCapsules,
	faCaretDown,
	faCaretRight,
	faCaretUp,
	faCartPlus,
	faChalkboardTeacher,
	faChartBar,
	faChartColumn,
	faChartLine,
	faChartPie,
	faCheck,
	faCheckCircle,
	faCheckDouble,
	faCheckSquare,
	faChessRook,
	faAnglesDown,
	faChevronDown,
	faChevronLeft,
	faChevronRight,
	faChevronUp,
	faCircle,
	faCircleExclamation,
	faCircleNotch,
	faClipboard,
	faClipboardCheck,
	faClipboardQuestion,
	faClock,
	faClockRotateLeft,
	faClosedCaptioning,
	faCloud,
	faCloudDownloadAlt,
	faCloudRain,
	faCloudSun,
	faCode,
	faCodeBranch,
	faCog,
	faCoins,
	faComment,
	faCommentDollar,
	faComments,
	faCopy,
	faCross,
	faCrown,
	faCubes,
	faDeleteLeft,
	faDollarSign,
	faDownload,
	faEdit,
	faEllipsisH,
	faEllipsisV,
	faEnvelope,
	faEnvelopeOpen,
	faEnvelopeOpenText,
	faExchangeAlt,
	faExclamation,
	faExclamationCircle,
	faExclamationTriangle,
	faExpandArrowsAlt,
	faExternalLinkAlt,
	faEye,
	faEyeSlash,
	faFeather,
	faFile,
	faFileAlt,
	faFileArchive,
	faFileContract,
	faFileDownload,
	faFileImport,
	faFileInvoice,
	faFileInvoiceDollar,
	faFileExcel,
	faFilePdf,
	faFileUpload,
	faFilter,
	faFire,
	faFireFlameCurved,
	faFlag,
	faFloppyDisk,
	faFolderPlus,
	faGift,
	faGlobe,
	faGlobeAmericas,
	faGraduationCap,
	faGripLines,
	faGaugeHigh,
	faHandHoldingDollar,
	faHandHoldingWater,
	faHandPointer,
	faHandshake,
	faHandshakeAngle,
	faHashtag,
	faHeadphones,
	faHeart,
	faHome,
	faHourglassStart,
	faIcons,
	faImage,
	faInfinity,
	faInfo,
	faInfoCircle,
	faInbox,
	faKey,
	faLayerGroup,
	faLightbulb,
	faLink,
	faList,
	faListAlt,
	faListUl,
	faLocationArrow,
	faLock,
	faLongArrowAltDown,
	faLongArrowAltUp,
	faMap,
	faMapMarkerAlt,
	faMapPin,
	faMinus,
	faMobile,
	faMoneyCheck,
	faMoon,
	faMountainSun,
	faMusic,
	faObjectUngroup,
	faPalette,
	faPaperclip,
	faPaperPlane,
	faPencilAlt,
	faPenNib,
	faPeopleCarryBox,
	faPercentage,
	faPhone,
	faPhoneAlt,
	faPlaneArrival,
	faPlay,
	faPlayCircle,
	faPlug,
	faPlus,
	faPlusCircle,
	faPlusSquare,
	faPoll,
	faPrint,
	faDiagramProject,
	faProjectDiagram,
	faPuzzlePiece,
	faQuestionCircle,
	faQuoteLeft,
	faQuoteRight,
	faRedo,
	faRedoAlt,
	faReply,
	faRobot,
	faRocket,
	faRotateRight,
	faSackDollar,
	faSearch,
	faShapes,
	faShare,
	faShareAlt,
	faShieldHalved,
	faShoppingCart,
	faSignInAlt,
	faSignOutAlt,
	faSitemap,
	faSlidersH,
	faSmileBeam,
	faSmog,
	faSnowflake,
	faSort,
	faSortAlphaDown,
	faSortAlphaUp,
	faSortAmountDown,
	faSortAmountUp,
	faSortNumericDown,
	faSortNumericUp,
	faSpinner,
	faStamp,
	faStar,
	faStarHalfAlt,
	faStickyNote,
	faStream,
	faSun,
	faSyncAlt,
	faTable,
	faTableList,
	faTag,
	faTags,
	faTasks,
	faTh,
	faThumbsUp,
	faThumbtack,
	faTicketAlt,
	faTimes,
	faTimesCircle,
	faTint,
	faTools,
	faTrash,
	faTrashAlt,
	faTriangleExclamation,
	faTrophy,
	faTruck,
	faTruckFast,
	faTruckPlane,
	faTruckRampBox,
	faUnlockAlt,
	faUndo,
	faUpload,
	faUser,
	faUserCircle,
	faUserClock,
	faUserFriends,
	faUserGraduate,
	faUserPlus,
	faUsers,
	faUserTie,
	faUtensils,
	faVideo,
	faWrench,
	faYenSign,
} from '@fortawesome/free-solid-svg-icons';

library.add(
	faHandPointer,
	faHandshake,
	faMoneyCheck,
	faClockRotateLeft,
	faFolderPlus,
	faFloppyDisk,
	faRotateRight,
	faGolang,
	faDeleteLeft,
	faBars,
	faArrowsRotate,
	faUserTie,
	faUpload,
	faTruckFast,
	faBoxOpen,
	faBox,
	faThumbsUp,
	faYenSign,
	faCoins,
	faUserClock,
	faPeopleCarryBox,
	faClipboardQuestion,
	faWatchmanMonitoring,
	faHandshakeAngle,
	faBarsStaggered,
	faBoxes,
	faCubes,
	faClipboardCheck,
	faStamp,
	faStickyNote,
	faCommentDots,
	faQuoteLeft,
	faQuoteRight,
	faFeather,
	faHourglassStart,
	faMountainSun,
	faFireFlameCurved,
	faPlaneArrival,
	faTruckPlane,
	faTruckRampBox,
	faHandHoldingDollar,
	faSackDollar,
	faFileContract,
	faPaperPlane,
	faSpinner,
	faAdjust,
	faExclamation,
	faCircleExclamation,
	faTriangleExclamation,
	faWindowRestore,
	faCalendarDays,
	faCalendarDay,
	faAngleUp,
	faAngleDown,
	faShieldHalved,
	faRobot,
	// Solid
	faClipboard,
	faEnvelopeOpenText,
	faFileDownload,
	faObjectUngroup,
	faPhoneAlt,
	faKey,
	faFileImport,
	faTicketAlt,
	faChartBar,
	faChartColumn,
	faChartPie,
	faGaugeHigh,
	faDiagramProject,
	faTableList,
	faCopy,
	faChessRook,
	faSearch,
	faHome,
	faBell,
	faPlay,
	faChevronRight,
	faChevronLeft,
	faChevronUp,
	faChevronDown,
	faAnglesDown,
	faExchangeAlt,
	faAngleRight,
	faAngleLeft,
	faEllipsisH,
	faCrown,
	faListAlt,
	faCheck,
	faBan,
	faUndo,
	faStream,
	faArrowsAltV,
	faSort,
	faSortAlphaDown,
	faSortAlphaUp,
	faSortNumericDown,
	faSortNumericUp,
	faSortAmountDown,
	faSortAmountUp,
	faCheckCircle,
	faUserCircle,
	faQuestionCircle,
	faLock,
	faCircle,
	faHeart,
	faShareAlt,
	faCaretRight,
	faArrowDown,
	faArrowTrendDown,
	faArrowUp,
	faArrowLeft,
	faArrowRight,
	faPrint,
	faDollarSign,
	faLink,
	faPlus,
	faPlusCircle,
	faMinus,
	faUser,
	faPencilAlt,
	faCamera,
	faTimesCircle,
	faSignInAlt,
	faBook,
	faPuzzlePiece,
	faTrash,
	faAlignLeft,
	faAlignRight,
	faPlug,
	faTimes,
	faFilter,
	faExternalLinkAlt,
	faCartPlus,
	faShoppingCart,
	faSitemap,
	faStar,
	faStarHalfAlt,
	faArchive,
	faEnvelope,
	faClock,
	faStar,
	faReply,
	faLocationArrow,
	faCog,
	faPaperclip,
	faImage,
	faEllipsisV,
	faEnvelopeOpen,
	faRedo,
	faSlidersH,
	faTrashAlt,
	faFileArchive,
	faFileExcel,
	faFilePdf,
	faFileAlt,
	faEye,
	faCaretUp,
	faCodeBranch,
	faExclamationTriangle,
	faListUl,
	faTh,
	faTruck,
	faGift,
	faUsers,
	faGlobeAmericas,
	faGlobe,
	faPlusSquare,
	faCaretDown,
	faUserPlus,
	faCircleNotch,
	faExclamation,
	faThumbsUp,
	faComments,
	faPalette,
	faYenSign,
	faEdit,
	faTrashAlt,
	faShare,
	faCheckSquare,
	faTools,
	faCheckDouble,
	faSmileBeam,
	faPoll,
	faPercentage,
	faTags,
	faIcons,
	faList,
	faUserFriends,
	faExclamationCircle,
	faFolderPlus,
	faTag,
	faAt,
	faCalendarAlt,
	faCalendarCheck,
	faCalendarDay,
	faMapMarkerAlt,
	faCross,
	faFlag,
	faThumbtack,
	faTable,
	faChartLine,
	faShapes,
	faMap,
	faFire,
	faLayerGroup,
	faLightbulb,
	faRocket,
	faWrench,
	faSun,
	faMoon,
	faInfoCircle,
	faSpinner,
	faCapsules,
	faTasks,
	faCloud,
	faCloudDownloadAlt,
	faCloudRain,
	faCloudSun,
	faSmog,
	faSnowflake,
	faSyncAlt,
	faBug,
	faProjectDiagram,
	faBolt,
	faPaperPlane,
	faLongArrowAltDown,
	faLongArrowAltUp,
	faInfinity,
	faFile,
	faMusic,
	faMobile,
	faBookOpen,
	faTint,
	faEyeSlash,

	// Brand
	faFacebook,
	faFacebookF,
	faFacebookSquare,
	faLinkedin,
	faInstagram,
	faPinterest,
	faGulp,
	faNodeJs,
	faSass,
	faTwitter,
	faGooglePlusG,
	faLinkedinIn,
	faMediumM,
	faHotjar,
	faYoutube,
	faVideo,
	faInfo,
	faInbox,
	faPhone,
	faTrello,
	faCode,
	faJs,
	faHtml5,
	faTrophy,

	// Regular
	farHeart,
	farLightbulb,
	farObjectUngroup,
	farPaperPlane,
	farStar,
	farImage,
	farFileArchive,
	farFileExcel,
	farFilePdf,
	farFileWord,
	farFile,
	farFileVideo,
	farFileAudio,
	farFileImage,
	farFileCode,
	farClock,
	farQuestionCircle,
	farDizzy,
	farLaughBeam,
	farSmileBeam,
	farCircle,
	farCopy,
	farComment,
	farEdit,
	farSquareCheck,
	faRedoAlt,
	faUserGraduate,
	faChalkboardTeacher,
	faGraduationCap,
	faSignOutAlt,
	faDownload,
	faFileUpload,
	faExpandArrowsAlt,
	faUnlockAlt,
	faGripLines,
	faComment,
	faHeadphones,
	faClosedCaptioning,
	faMapPin,
	faPlayCircle,
	faPenNib,
	faAward,
	faBrush,
	faHashtag,
	faFileInvoice,
	faFileInvoiceDollar,
	faBalanceScaleLeft,
	faCommentDollar,
	faHandHoldingWater,
	faCameraRetro,
	faUtensils,
	faBuilding,
);
